import React from 'react';
import { ContentfulGenericPage } from '@jbhi-fi/apis/src/contentful/types';
import { CardGridCardProps } from '../../ContentCard/CardGrid/CardGrid';
import { CardTransformer } from './CardTransformer';
import { ContentCardCoverImage } from '../../ContentCard';
import { format, parseISO } from 'date-fns';

export abstract class GenericPageTransformer {
  static toCardProps = (entry?: ContentfulGenericPage): CardGridCardProps => {
    const coverImageProps = CardTransformer.toCardCoverImageProps(entry);
    const publishedDate = entry?.fields?.publishedDate || entry?.sys?.createdAt;
    return {
      heading: entry?.fields?.heading,
      cover: coverImageProps ? <ContentCardCoverImage {...coverImageProps} /> : null,
      tagProps: CardTransformer.toTagProps(entry),
      footerProps: {
        leftContent: publishedDate ? format(parseISO(publishedDate), 'd MMM yyyy') : '',
        rightContent: entry?.fields?.parentPage?.fields?.heading,
      },
      showTag: false,
      href: CardTransformer.toHref(entry),
    };
  };
}
